<div class="input-form input-text">
  <input
    [ngClass]="{'readonly': readonly}"
    [type]="type"
    [name]="name"
    [value]="value"
    [required]="required"
    [disabled]="disabled"
    [readonly]="readonly"
    (input)="onInput($event)"
    autocomplete="new-password"
  />
  <span class="highlight"></span>
  <span class="bar"></span>
  <i
    *ngIf="isInputPass()"
    (click)="onClickEye()"
    class="glyphicon"
    [ngClass]="{'glyphicon-eye-open': hidePass,'glyphicon-eye-close': !hidePass}"
  ></i>
  <label
    [for]="name"
    [innerHTML]="label"
  ></label>
</div>
<span
  *ngIf="hasInputError"
  class="error"
>{{ inputErrorMessage }}</span>
